import React, { useState } from 'react';
import Alert from '@mui/material/Alert';
import { AlertTitle, Button, Collapse, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({    
    alerts: {
        position: 'fixed',
        right: theme.spacing(4),
        bottom: theme.spacing(4),
    },
    box_alert: {
        padding: theme.spacing(1, 0)
    },
}));

export default function CustomAlerts(props) {
    const classes = useStyles();
    const {t} = useTranslation();
    const { alerts } = props;

    return (
        <Grid item className={classes.alerts}>
            {alerts && alerts.length > 0 && alerts.map((alert, index) => (
                <Grid item key={index} className={classes.box_alert}>
                    <AlertItem
                        type={alert.type ? alert.type : null}
                        title={alert.title ? alert.title : null}
                        enableClose={alert.enableClose ? alert.enableClose : null}
                        message={alert.message ? alert.message : null}
                    />
                </Grid>
            ))}
        </Grid>
    );
}

function AlertItem(props) {
    const { t } = useTranslation();
    const classes = useStyles();
    const { type, title, enableClose, message, customAction } = props;
    const [open, setOpen] = useState(true);

    //type: error, warning, info, success
    return (
        <Collapse in={open}>
            <Alert
                severity={type ? type : 'info'}
                onClose={enableClose ? () => {setOpen(false) } : null}
                action={
                    customAction ? customAction : null
                }
                className={classes.root}
            >
                <AlertTitle>
                    {title ? title : null}
                </AlertTitle>
                {message ? message : null}
            </Alert>
        </Collapse>
    );
}